import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PortalUser {
  id: string;
  email: string;
  role: string;
  tenant_id: string | null;
  linked_id: string;
  is_active: boolean;
  meta: any;
  created_at: string;
  last_login_at: string | null;
}

export function usePortalUsers(role?: string) {
  return useQuery({
    queryKey: ['portal-users', role],
    queryFn: async () => {
      let query = supabase
        .from('portal_users')
        .select('*')
        .eq('is_active', true)
        .order('email');

      if (role) {
        query = query.eq('role', role);
      }

      const { data, error } = await query;
      
      if (error) throw error;
      return (data || []) as PortalUser[];
    },
  });
}
